// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__5D1PS","overlay":"styles_overlay__NqS0m","modal_close_button":"styles_modal_close_button__SSL8B"};